var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLocationIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 23,
    viewBox: "0 0 20 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0c2.6522 0 5.1957 1.03852 7.0711 2.88709C18.9464 4.73566 20 7.24287 20 9.85714c0 4.08086-3.1556 8.35666-9.3333 12.92386-.1924.1421-.4263.219-.6667.219-.24041 0-.47434-.0769-.66667-.219C3.15556 18.2138 0 13.938 0 9.85714c0-2.61427 1.05357-5.12148 2.92893-6.97005C4.8043 1.03852 7.34784 0 10 0zm0 6.57143c-.88405 0-1.7319.34617-2.35702.96236-.62512.61619-.97631 1.45193-.97631 2.32335 0 .87146.35119 1.70716.97631 2.32336.62512.6162 1.47297.9624 2.35702.9624.8841 0 1.7319-.3462 2.357-.9624.6251-.6162.9763-1.4519.9763-2.32336 0-.87142-.3512-1.70716-.9763-2.32335S10.8841 6.57143 10 6.57143z",
    fill: "#112452"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIcon);
export default __webpack_public_path__ + "static/media/location_icon.b123f7709807cb4f27bb92cfc7de6eed.svg";
export { ForwardRef as ReactComponent };